import FormSelect from 'components/Select/FormSelect';
import Text from 'components/Text/Text';
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { IItemForGetShortInfo } from 'types';
import { Checkbox } from 'antd';
import SearchField from 'components/SearchField/SearchField';
import style from './MultipleSelect.module.scss';

interface IMultipleSelect {
	data: IItemForGetShortInfo[];
	isLoading: boolean;
	refetch: () => void;
	responseError: boolean;
	setIDsSubcategories: (value: string[]) => void;
	IDsSelectedCategories: string[];
	IDsSelectedSubcategories: string[];
}

const MultipleSelect: React.FC<IMultipleSelect> = ({
	data,
	isLoading,
	refetch,
	responseError,
	IDsSelectedCategories,
	IDsSelectedSubcategories,
	setIDsSubcategories,
}) => {
	const [searchString, setSearchString] = useState<string>('');

	const filteredData = useMemo(() => {
		return searchString ? data.filter((el) => el.name.toLowerCase().includes(searchString.toLowerCase())) : data;
	}, [searchString, data]);

	const handleSelectAllData = useCallback(() => {
		if (data.length === IDsSelectedSubcategories.length) {
			setIDsSubcategories([]);
		} else {
			const IDsOfAllDishes = data.map((el) => el.id);
			setIDsSubcategories(IDsOfAllDishes);
		}
	}, [data, IDsSelectedSubcategories, setIDsSubcategories]);

	useEffect(() => {
		setSearchString('');
	}, [IDsSelectedCategories]);

	const renderSelectMenu = useCallback(
		(menu: React.ReactElement) => {
			return (
				<>
					<div className={style.selectMenuHeader}>
						<Checkbox
							className={style.checkBox}
							checked={!!(data.length && data.length === IDsSelectedSubcategories.length)}
							disabled={!data.length}
							onChange={handleSelectAllData}>
							<Text
								translationNameSpace="form"
								translationKey="selectAllSubcategoriesLabel"
								asFragment={true}
							/>
						</Checkbox>
						<SearchField
							onChangeSelectSearchString={setSearchString}
							searchString={searchString}
							className={style.searchField}
						/>
					</div>
					{menu}
				</>
			);
		},
		[data, IDsSelectedSubcategories, handleSelectAllData, setSearchString, searchString],
	);

	return (
		<FormSelect
			name="IDsSelectedSubcategories"
			label="subcategoriesLabel"
			options={filteredData}
			fetchError={responseError}
			loading={isLoading}
			onRefetch={refetch}
			disabled={!IDsSelectedCategories.length || isLoading}
			onChange={setIDsSubcategories}
			counterValue={IDsSelectedSubcategories.length}
			dropdownRender={renderSelectMenu}
			mode="multiple"
		/>
	);
};

export default React.memo(MultipleSelect);
